<script setup lang="ts">
import type { PageData } from '@/types';
import Sections from './sections/ContentSections.vue';
import PageNav from './page-nav/PageNav.vue';

defineProps<{
  pageData: PageData;
  hideMobilePageNav?: boolean;
}>();
</script>

<template>
  <main class="page-content" :class="{ 'is-nav-hidden': hideMobilePageNav }">
    <PageNav
      class="page-content-nav"
      :sections="pageData"
    />
    <Sections
      class="page-sections"
      :page-data="pageData"
    />
  </main>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.page-content {
  position: relative;
  margin-top: var(--spacing-xl);
  display: grid;
  grid-template: "container";
  align-items: start;

  @include screen.respond(tablet) {
    padding-left: 4.8rem; // add extra padding as a stopgap for too-wide layout on large tablets
    padding-right: 4.8rem;
    margin-top: 0;
    display: block;
  }
  @include screen.respond(mobile) {
    padding-left: 0;
    padding-right: 0;
  }

  &.is-nav-hidden {
    @include screen.respond(tablet) {
      .page-content-nav {
        display: none;
      }
      .page-sections {
        margin-top: var(--spacing-ml);
      }
    }
  }
}
.page-content-nav {
  grid-area: container;
  position: sticky;
  top: var(--spacing-l);
  left: 0;
  z-index: 100;

  @include screen.respond(tablet) {
    position: static;
  }
}
.page-sections {
  grid-area: container;
  margin-top: 0;

  :deep([id]) {
    scroll-margin-top: var(--spacing-l);
  }
}
</style>
